var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggleWrapper",on:{"click":_vm.toggle}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"toggleBg",class:_vm.toggleState},[_c('div',{staticClass:"dot"})])])}
var staticRenderFns = []

export { render, staticRenderFns }